<script lang="ts" setup>
  import type { ICurrencyData } from '~/store/cashier';

  const props = defineProps<{
    list: ICurrencyData[];
  }>();

  const selectedCurrency = defineModel<ICurrencyData>('currency');
  const isOpen = defineModel<boolean>('open');

  const searchString = ref('');
  const filteredList = computed(() => {
    if (!searchString.value) return props.list;

    const search = searchString.value.toLowerCase();
    return props.list.filter(
      ({ text, subtitle }) => text.toLowerCase().includes(search) || subtitle.toLowerCase().includes(search),
    );
  });

  function selectCurrency(currency: ICurrencyData) {
    selectedCurrency.value = currency;
    isOpen.value = false;
  }
</script>

<template>
  <div>
    <div
      v-if="isOpen"
      class="flex w-full py-3 px-0 flex-col items-start gap-3 rounded-xl bg-black/10 font-barlow text-white"
    >
      <div class="w-full px-4">
        <UInput
          v-model="searchString"
          :ui="{
            base: 'ps-10 h-[43px] rounded-6px text-[#999] text-[20px] font-semibold leading-[1.3] placeholder:text-[#999]',
            leadingIcon: 'bg-[#999] size-6',
          }"
          icon="i-lucide-search"
          placeholder="Search"
          size="md"
          variant="subtle"
        />
      </div>

      <p class="mx-4 text-[#E7E5EC] text-lg font-bold leading-tight">Choose your crypto</p>

      <CashierCurrencyItem
        v-for="currency in filteredList"
        :key="currency.value"
        :currency="currency"
        @click="selectCurrency(currency)"
      />
    </div>
    <div
      v-else
      class="flex w-full h-[42px] px-5 py-0 justify-between items-center rounded-6px bg-white/20 hover:bg-white/25 cursor-pointer"
      @click="isOpen = true"
    >
      <div class="font-barlow text-sm font-semibold leading-none">
        <div v-if="selectedCurrency" class="flex items-center gap-1.5">
          <CoreImage :src="`/images/currencies/${selectedCurrency.icon}`" class="size-4" />
          <span class="text-white text-sm font-semibold leading-none">
            <span class="font-semibold">{{ selectedCurrency.text }}</span>
            <span class="font-medium">&nbsp;({{ selectedCurrency.subtitle }})</span>
          </span>
        </div>
        <span v-else>Select Currency</span>
      </div>

      <UIcon name="i-lsicon-triangle-down-filled" />
    </div>
  </div>
</template>
